import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import BottomImg from '../../images/page-bottom.png';
import { motion } from 'framer-motion';

export default function PageSubTitle({ pagename }) {
    return (
        <>
            <motion.section initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className='page-hero floating-icons-container overflow-hidden position-relative'>
                <Container>
                    <Row>
                        <Col md={12} className='text-center'>
                            <motion.h1 initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='display-4 fw-medium'>{pagename}</motion.h1>
                            <motion.nav initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center">
                                    <motion.li initial={{opacity: 0, x: -20}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}} className="breadcrumb-item">Reshto</motion.li>
                                    <motion.li initial={{opacity: 0, x: 20}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}} className="breadcrumb-item active" aria-current="page">{pagename}</motion.li>
                                </ol>
                            </motion.nav>
                        </Col>
                    </Row>
                </Container>
                <Image className='page-bottom-img' src={BottomImg} alt="" />
            </motion.section>
        </>
    )
}
